import styles from './mochi-tooptip.module.sass';

export interface MochiTooltipProps {
  children: React.ReactNode;
  title: string;
  className?: string;
  position?: [number, number];
  arrowPosition?: number;
  isOpen?: boolean;
}

export const MochiTooltip = ({
  children,
  title,
  className,
  position = [0, 0],
  arrowPosition = 0,
  isOpen = false,
}: MochiTooltipProps) => {
  if (isOpen === false)
    return (
      <div className={`${styles['tool-tip-container']} ${className}`}>
        {children}
      </div>
    );

  return (
    <div className={`${styles['tool-tip-container']} ${className}`}>
      <div className={styles['tool-tip-inner-container']}>
        {children}
        <span
          className={styles['tool-tip-title']}
          style={{ transform: `translate(${position[0]}px, ${position[1]}px)` }}
        >
          {title}
          <span
            className={styles['tool-tip-triangle-icon']}
            style={{ left: `calc(50% + ${arrowPosition}px)` }}
          />
        </span>
      </div>
    </div>
  );
};
